import { createElementVNode as _createElementVNode, openBlock as _openBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/BotonPSE.png'
import _imports_1 from '@/assets/img/refinancia/logo-mo-28.svg'


const _withScopeId = n => (_pushScopeId("data-v-c0a7b76a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white w-full" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "p-4 bg-primary rounded-full" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "h-10 w-10 text-white",
      fill: "none",
      viewBox: "0 0 24 24",
      stroke: "currentColor"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
      })
    ])
  ])
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-primary font-extrabold py-4" }, [
  /*#__PURE__*/_createTextVNode(" Actualmente no es posible cargar su información en nuestra plataforma. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Estamos trabajando para solucionarlo ")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gris80 font-extrabold" }, " Por el momento, por favor utilice los siguientes canales: ", -1))
const _hoisted_5 = { class: "bg-lightSurface-50 mt-4 rounded-lg p-6 text-center text-sm" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "pse",
  class: "btn-pse"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gris80 font-extrabold pb-4 text-left mt-4" }, [
  /*#__PURE__*/_createTextVNode(" Para pedir su paz y salvo, estado de obligación, o resúmen de pago: "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gris120" }, [
    /*#__PURE__*/_createTextVNode("Solicitelo en "),
    /*#__PURE__*/_createElementVNode("a", { class: "link font-bold cursor-pointer underline" }, "contactenos@sc.jccolombia.co"),
    /*#__PURE__*/_createTextVNode(" con su nombre y cédula.")
  ])
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Solicitud", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-md text-gris120 font-bold pt-4 text-center" }, "Gracias", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-36",
    src: _imports_1,
    alt: "logo referencia"
  })
], -1))
const _hoisted_11 = {
  href: "",
  ref: "iPhoneLink",
  rel: "noreferrer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NewModal = _resolveComponent("NewModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isVisible)
      ? (_openBlock(), _createBlock(_component_NewModal, {
          key: 0,
          "custom-class": 'p-4 lg:p-6 max-w-2xl w-80 lg:w-88 bg-white rounded-lg',
          onCloseModal: _ctx.close
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _hoisted_2,
              _hoisted_3,
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("button", {
                  type: "button",
                  class: "py-2 text-sm mt-3 text-white rounded-lg w-52 md:w-48 md:mt-0 md:text-sm order-first md:order-none btn-pse-container",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.redirectPse && _ctx.redirectPse(...args)), ["prevent"]))
                }, [
                  _hoisted_6,
                  _createTextVNode(" Pagar su cuota por ")
                ]),
                _hoisted_7,
                _createElementVNode("button", {
                  type: "button",
                  class: "py-2 px-8 text-xs text-white rounded-lg w-52 md:w-48 bg-secondary md:text-sm",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.redirectPqr && _ctx.redirectPqr(...args)), ["prevent"]))
                }, [
                  _createTextVNode(" Radicar una "),
                  _hoisted_8
                ])
              ]),
              _hoisted_9,
              _hoisted_10
            ])
          ]),
          _: 1
        }, 8, ["onCloseModal"]))
      : _createCommentVNode("", true),
    _createElementVNode("a", _hoisted_11, null, 512)
  ], 64))
}